import React, { forwardRef, HTMLAttributes } from 'react';
import { cn } from '@/utils/styles';

interface CardProps extends HTMLAttributes<HTMLDivElement> {
  children?: React.ReactNode;
  className?: string;
  as?: React.ElementType;
  dark?: boolean;
  shadow?: boolean;
  border?: boolean;
}

const Card = forwardRef<HTMLDivElement, CardProps>(
  (
    {
      as = 'div',
      children,
      className,
      dark = false,
      shadow = true,
      border = true,
      ...props
    },
    ref,
  ) => {
    const Tag = as;
    const bg = dark ? 'bg-neutral-1000' : 'bg-neutral-900';
    return (
      <Tag
        ref={ref}
        className={cn(
          'overflow-hidden rounded-md border-neutral-700',
          {
            'shadow-lg': shadow,
            'border-1': border,
          },
          className,
          bg,
        )}
        {...props}>
        {children}
      </Tag>
    );
  },
);

Card.displayName = 'Card';
export default Card;
